const wrapper = "_uxswlr4bzc";
const horisontal = "_uxshmetzmp";
const withoutHeadingSpacer = "_uxsw15sctb7";

export { horisontal, withoutHeadingSpacer, wrapper };
import "./_page-content.style.linaria.module.css";
//# sourceMappingURL=_page-content.style.js.map
